import React, { useEffect } from "react";
import { useWizard, Wizard } from "react-use-wizard";
import { RightsPage } from "./RightsPage";
import { RightsIntersectionsPage } from "../rights-intersections/RightsIntersectionsPage";
import cn from "classnames";
import { twMerge } from "tailwind-merge";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useComponentDidMount } from "../../hooks/use-component-did-mount";
import { useAuth } from "../../contexts/AuthContext";
import { RightsIssuesPage } from "../rights-issues/RightsIssuesPage";

type WizardHeaderProps = {
  activeStepFromUrl: number;
}
const WizardHeader: React.FC<WizardHeaderProps> = ({ activeStepFromUrl }) => {
  const { activeStep, goToStep } = useWizard();
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const isMounted = useComponentDidMount();
  useEffect(() => {
    goToStep(activeStepFromUrl);
  }, [activeStepFromUrl]);

  useEffect(() => {
    if (isMounted) {
      setSearchParams();
    }
  }, [activeStep]);

  return <>
    <div className={"flex align-items-center justify-between"}>
      <ul className="flex flex-wrap text-md font-medium text-center m-0 p-0 text-gray-500 dark:text-gray-400">
        <li className={cn("me-2")} onClick={() => {
          navigate("/rights");
        }}>
            <span
              aria-current="page"
              style={{
                position: "relative",
                bottom: "-2px",
                backgroundColor: "white"
              }}
              className={twMerge(
                cn(
                  "inline-block p-3 border-r-2 border-l-2 border-t-2 rounded-t-lg cursor-pointer active dark:bg-gray-800 dark:text-blue-500",
                  {
                    "bg-gray-50": activeStep !== 0,
                    "border-0": activeStep !== 0
                  }
                )
              )}
            >
              Авторские права
            </span>
        </li>
        {
          user?.is_uma_employee &&
          <li className={cn("me-2")} onClick={() => navigate("/rights_intersections")}>
            <span
              aria-current="page"
              style={{
                position: "relative",
                bottom: "-2px",
                backgroundColor: "white"
              }}
              className={twMerge(
                cn(
                  "inline-block p-3 border-r-2 border-l-2 border-t-2 rounded-t-lg cursor-pointer active dark:bg-gray-800 dark:text-blue-500",
                  {
                    "bg-gray-50": activeStep !== 1,
                    "border-0": activeStep !== 1
                  }
                )
              )}
            >
              Пересечение прав
            </span>
          </li>
        }
        <li className={cn("me-2")} onClick={() => navigate("/rights_issues")}>
            <span
              aria-current="page"
              style={{
                position: "relative",
                bottom: "-2px",
                backgroundColor: "white"
              }}
              className={twMerge(
                cn(
                  "inline-block p-3 border-r-2 border-l-2 border-t-2 rounded-t-lg cursor-pointer active dark:bg-gray-800 dark:text-blue-500",
                  {
                    "bg-gray-50": activeStep !== 2,
                    "border-0": activeStep !== 2
                  }
                )
              )}
            >
              Конфликты
            </span>
        </li>
      </ul>
    </div>

  </>;
};

type RightsProps = {
  activeStep: number;
}

export const Rights: React.FC<RightsProps> = ({ activeStep }) => {
  return <>
    <Wizard startIndex={activeStep} header={<WizardHeader activeStepFromUrl={activeStep} />}>
      <RightsPage />
      <RightsIntersectionsPage />
      <RightsIssuesPage />
    </Wizard>
  </>;
};
